import React, {useEffect, useState} from 'react';
import FileUpload from "../../FileUploads/FileUpload";
import SearchLocation from "../../searchLocation/searchLocation";
import Loader from "../../../Loader/Loader";

const Society = ({
                     documentUploadUrlPublic,
                     documentUrlDataPublic,
                     getCityStateByPincode,
                     pincodeData = [],
                     dropdownValue = [],
                     handleInput,
                     locationCity = [],
                     locationZone,
                     locationArea,
                     zones = [],
                     areas = [],
                     inputList,
                     accountDetailsByIdData,
                     isEdit = false,
                     isView = false,
                     stateRegionDetails=[],
                     stateAndRegion
                 }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [evVehicle, setEvVehicle] = useState('');
    const [existingSetupSocietyYes, setExistingSetupSocietyYes] = useState(0);
    const [fmcName, setFmcName] = useState(0);
    const [barrierMake, setBarrierMake] = useState(0);
    const [leadSource, setLeadSource] = useState('');
    const [alternativeChannelId, setAlternativeChannel] = useState(0)
    const [bankAccountName, setBankAccountName] = useState(0)
    const [occupancyId, setOccupancyId] = useState(0);
    const [inboundChannelId, setInboundChannelId] = useState(0)
    const [securityAgencyId, setSecurityAgencyId] = useState(0)
    const [amenitiesId, setAmenitiesId] = useState(0)
    const [barrierTypeId, setBarrierTypeId] = useState(0)
    const [regionId, setRegionId] = useState(0)
    const [ageOfBarrier, setAgeOfBarrier] = useState(0)
    const [amcOfCurrentSetup, setAmcOfCurrentSetup] = useState('')
    const [ReaderMake, setReaderMake] = useState('');
    const [ageOfSetUp, ReaderAgeOfSetUp] = useState('');
    const [cityId, setCityId] = useState(0)
    const [zoneId, setZoneId] = useState(0)
    const [areaId, setAreaId] = useState(0)
    const [stateId, setStateId] = useState(0)
    const [vmsId, setVmsId] = useState(0)
    const [enterprisePartnerId, setEnterPricePartnerId] = useState(0)
    const [distributePartnerId, setDistributePartnerId] = useState(0)
    const [societyConflictLevel, setSocietyConflictLevel] = useState('')
    const [parkingSlotId, setParkingSlotId] = useState('')
    const [boomBarrierImage, setBoomBarrierImage] = useState('')
    const [pincodeValue, setPincodeValue] = useState('')
    const [lat, setLat] = useState('')
    const [long, setLong] = useState('')
    const [images, setImages] = useState([])
    const [readerImages, setReaderImages] = useState('')
    const [state, setState] = useState('')
    const [regionName, setRegion] = useState('')

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(true)
            setIsLoading(false)
        },500)
    }, [])

    useEffect(() => {
        if (boomBarrierImage !== '') {
            images[0] = boomBarrierImage
        }
        setImages(images)
        setTimeout(() => {
            setIsLoading(true)
            setIsLoading(false)
        }, 500)
    }, [boomBarrierImage])

    useEffect(() => {
        if (readerImages !== '') {
            images[1] = readerImages
        }
        setImages(images)
        setTimeout(() => {
            setIsLoading(true)
            setIsLoading(false)
        }, 500)
    }, [readerImages])

    useEffect(() => {
        getCityStateByPincode(pincodeValue)
    }, [pincodeValue])

    useEffect(() => {
        handleInput(ReaderMake, 'reader_make_id')
    }, [ReaderMake])

    useEffect(() => {
        handleInput(ageOfSetUp, 'reader_age_of_setup')
    }, [ageOfSetUp])

    useEffect(() => {
        if(parseInt(leadSource) === 10 || parseInt(leadSource) === 9){
            setAlternativeChannel('')
            setDistributePartnerId('')
            setInboundChannelId('')
            setEnterPricePartnerId('')
        }
        handleInput(leadSource, 'lead_source_id')
    }, [leadSource])

    // useEffect(() => {
    //     handleInput(societyTypeId, 'society_type_id')
    // }, [societyTypeId])

    useEffect(() => {
        handleInput(alternativeChannelId, 'alternative_channel_id')
    }, [alternativeChannelId])

    useEffect(() => {
        handleInput(evVehicle, 'ev_vehicle')
    }, [evVehicle])

    useEffect(() => {
        handleInput(bankAccountName, 'bank_account_name_id')
    }, [bankAccountName]);

    useEffect(() => {
        handleInput(occupancyId, 'occupancy_id')
    }, [occupancyId])

    // useEffect(() => {
    //     handleInput(stateRegionDetails?.region_id, 'region')
    // }, [regionId])

    useEffect(() => {
        handleInput(inboundChannelId, 'inbound_channel_id')
    }, [inboundChannelId])

    useEffect(() => {
        handleInput(securityAgencyId, 'security_agency_id')
    }, [securityAgencyId])

    useEffect(() => {
        handleInput(amenitiesId, 'amenity_id')
    }, [amenitiesId])

    useEffect(() => {
        setState('')
        setRegion('')
        if(stateRegionDetails?.state_id !== undefined){
            handleInput(stateRegionDetails?.state_id, 'state_id')
            handleInput(stateRegionDetails?.region_id, 'region')
            setState(stateRegionDetails?.state_name)
            setRegion(stateRegionDetails?.region_name)
        }
    }, [stateRegionDetails])

    useEffect(() => {
        handleInput(barrierMake, 'barrier_make_id')
    }, [barrierMake])

    useEffect(() => {
        handleInput(barrierTypeId, 'barrier_type_id')
    }, [barrierTypeId])

    useEffect(() => {
        handleInput(ageOfBarrier, 'age_of_barrier')
    }, [ageOfBarrier])

    useEffect(() => {
        handleInput(amcOfCurrentSetup, 'amc_of_current_setup')
    }, [amcOfCurrentSetup])

    useEffect(() => {
        (async () => {
            handleInput(cityId, 'city_id')
            await locationZone(cityId !== 0 ? cityId : accountDetailsByIdData?.city_id)
            await stateAndRegion(cityId !== 0 ? cityId : accountDetailsByIdData?.city_id)
        })()
    }, [cityId])

    useEffect(() => {
        (async () => {
            handleInput(zoneId, 'zone_id')
            await locationArea(zoneId !==0 ? zoneId : accountDetailsByIdData?.zone_id)
        })()
    }, [zoneId])

    useEffect(() => {
        handleInput(areaId, 'area_id')
    }, [areaId])

    useEffect(() => {
        handleInput(enterprisePartnerId, 'enterprise_partner_id')
    }, [enterprisePartnerId])

    useEffect(() => {
        handleInput(distributePartnerId, 'distribute_channel_id')
    }, [distributePartnerId])

    useEffect(() => {
        handleInput(vmsId, 'vms_id')
    }, [vmsId])

    useEffect(() => {
        handleInput(fmcName, 'fmc_name_id')
    }, [fmcName])

    useEffect(() => {
        handleInput(existingSetupSocietyYes, 'existing_setup_society_id')
    }, [existingSetupSocietyYes])

    useEffect(() => {
        handleInput(societyConflictLevel, 'society_conflict_level')
    }, [societyConflictLevel])

    useEffect(() => {
        handleInput(parkingSlotId, 'parking_slot_type_id')
    }, [parkingSlotId])

    const [optOption, setOptOption] = useState({
        address2: '',
        currentLocation: '',
    });

    const handleCurrentLocationBlur = (latlng = null) => {
        if (latlng !== null && latlng !== undefined) {
            setLong(latlng?.lng)
            setLat(latlng?.lat)
            handleInput(latlng?.lng, 'longitude')
            handleInput(latlng?.lat, 'latitude')
        }
    };

    const handleCurrentLocationChange = (value) => {
        setOptOption({ ...optOption, currentLocation: value });
        if(!isEdit){
            handleInput(value, 'address_1')
        }
        handleInput(value, 'current_location')
    };

    const [isInputError, setIsInputError] = useState({
        latError: false,
        longError: false,
        pinError: false,
        crl: false,
        isPinNotFound: false,
    });

    useEffect(() => {
        if (accountDetailsByIdData !== [] && accountDetailsByIdData?.account_type_id !== undefined) {
            if (accountDetailsByIdData?.alternative_channel_id !== undefined &&
                accountDetailsByIdData?.alternative_channel_id !== null &&
                accountDetailsByIdData?.alternative_channel_id !== '') {
                setAlternativeChannel(accountDetailsByIdData?.alternative_channel_id)
            }

            if(accountDetailsByIdData?.current_location !== undefined &&
                accountDetailsByIdData?.current_location !== null &&
                accountDetailsByIdData?.current_location !== ''){
                setOptOption({ ...optOption, currentLocation: accountDetailsByIdData?.current_location });
            }

            if(accountDetailsByIdData?.latitude !== undefined &&
                accountDetailsByIdData?.latitude !== null &&
                accountDetailsByIdData?.latitude !== ''){
                setLat(accountDetailsByIdData?.latitude)
            }

            if(accountDetailsByIdData?.longitude !== undefined &&
                accountDetailsByIdData?.longitude !== null &&
                accountDetailsByIdData?.longitude !== ''){
                setLong(accountDetailsByIdData?.longitude)
            }

            if (accountDetailsByIdData?.ev_vehicle !== undefined &&
                accountDetailsByIdData?.ev_vehicle !== null &&
                accountDetailsByIdData?.ev_vehicle !== '') {
                setEvVehicle(accountDetailsByIdData?.ev_vehicle)
            }

            if (accountDetailsByIdData?.parking_slot_type_id !== undefined &&
                accountDetailsByIdData?.parking_slot_type_id !== null &&
                accountDetailsByIdData?.parking_slot_type_id !== '') {
                setParkingSlotId(accountDetailsByIdData?.parking_slot_type_id)
            }

            if (accountDetailsByIdData?.bank_account_name_id !== undefined &&
                accountDetailsByIdData?.bank_account_name_id !== null &&
                accountDetailsByIdData?.bank_account_name_id !== '') {
                setBankAccountName(accountDetailsByIdData?.bank_account_name_id)
            }

            if (accountDetailsByIdData?.occupancy_id !== undefined &&
                accountDetailsByIdData?.occupancy_id !== null &&
                accountDetailsByIdData?.occupancy_id !== '') {
                setOccupancyId(accountDetailsByIdData?.occupancy_id)
            }

            if (accountDetailsByIdData?.security_agency_id !== undefined &&
                accountDetailsByIdData?.security_agency_id !== null &&
                accountDetailsByIdData?.security_agency_id !== '') {
                setSecurityAgencyId(accountDetailsByIdData?.security_agency_id)
            }

            if (accountDetailsByIdData?.vms_id !== undefined &&
                accountDetailsByIdData?.vms_id !== null &&
                accountDetailsByIdData?.vms_id !== '') {
                setVmsId(accountDetailsByIdData?.vms_id)
            }

            if (accountDetailsByIdData?.fmc_name_id !== undefined &&
                accountDetailsByIdData?.fmc_name_id !== null &&
                accountDetailsByIdData?.fmc_name_id !== '') {
                setFmcName(accountDetailsByIdData?.fmc_name_id)
            }

            if (accountDetailsByIdData?.amenity_id !== undefined &&
                accountDetailsByIdData?.amenity_id !== null &&
                accountDetailsByIdData?.amenity_id !== '') {
                setAmenitiesId(accountDetailsByIdData?.amenity_id)
            }

            if (accountDetailsByIdData?.existing_setup_society_id !== undefined &&
                accountDetailsByIdData?.existing_setup_society_id !== null &&
                accountDetailsByIdData?.existing_setup_society_id !== '') {
                setExistingSetupSocietyYes(accountDetailsByIdData?.existing_setup_society_id)
            }

            if (accountDetailsByIdData?.barrier_type_id !== undefined &&
                accountDetailsByIdData?.barrier_type_id !== null &&
                accountDetailsByIdData?.barrier_type_id !== '') {
                setBarrierTypeId(accountDetailsByIdData?.barrier_type_id)
            }

            if (accountDetailsByIdData?.barrier_make_id !== undefined &&
                accountDetailsByIdData?.barrier_make_id !== null &&
                accountDetailsByIdData?.barrier_make_id !== '') {
                setBarrierMake(accountDetailsByIdData?.barrier_make_id)
            }

            if (accountDetailsByIdData?.age_of_barrier !== undefined &&
                accountDetailsByIdData?.age_of_barrier !== null &&
                accountDetailsByIdData?.age_of_barrier !== '') {
                setAgeOfBarrier(accountDetailsByIdData?.age_of_barrier)
            }

            setLeadSource(accountDetailsByIdData?.lead_source_id)
            // if(accountDetailsByIdData?.boom_barrier_image !== undefined &&
            //     accountDetailsByIdData?.boom_barrier_image !== null &&
            //     accountDetailsByIdData?.boom_barrier_image !== ''){
            //     setBoomBarrierImage(accountDetailsByIdData?.boom_barrier_image)
            // }
            handleInput(accountDetailsByIdData?.boom_barrier_image, 'boom_barrier_image')
            handleInput(accountDetailsByIdData?.reader_image, 'reader_image')
            handleInput(accountDetailsByIdData?.client_name, 'client_name')
            handleInput(accountDetailsByIdData?.lead_source_id, 'lead_source_id')
            handleInput(accountDetailsByIdData?.enterprise_partner_id, 'enterprise_partner_id')
            handleInput(accountDetailsByIdData?.inbound_channel_id, 'inbound_channel_id')
            handleInput(accountDetailsByIdData?.distribute_channel_id, 'distribute_channel_id')
            handleInput(accountDetailsByIdData?.region, 'region')
            handleInput(accountDetailsByIdData?.city_id, 'city_id')
            handleInput(accountDetailsByIdData?.zone_id, 'zone_id')
            handleInput(accountDetailsByIdData?.area_id, 'area_id')
            handleInput(accountDetailsByIdData?.address_1, 'address_1')
            handleInput(accountDetailsByIdData?.address_2, 'address_2')
            handleInput(accountDetailsByIdData?.pincode, 'pincode')
            setPincodeValue(accountDetailsByIdData?.pincode)
            handleInput(pincodeData?.geographical_city_id, 'geographical_city_id')
            handleInput(pincodeData?.geographical_city_id, 'geographical_city_id')
            handleInput(accountDetailsByIdData?.latitude, 'latitude')
            handleInput(accountDetailsByIdData?.longitude, 'longitude')
            handleInput(accountDetailsByIdData?.ev_vehicle, 'ev_vehicle')
            handleInput(accountDetailsByIdData?.no_of_ev_vehicles, 'no_of_ev_vehicles')
            handleInput(accountDetailsByIdData?.parking_slot_type_id, 'parking_slots')
            handleInput(accountDetailsByIdData?.total_parking_slot, 'total_parking_slot')
            handleInput(accountDetailsByIdData?.total_maintenance_per_month, 'total_maintenance_per_month')
            handleInput(accountDetailsByIdData?.bank_account_name_id, 'bank_account_name_id')
            handleInput(accountDetailsByIdData?.branch_name, 'branch_name')
            handleInput(accountDetailsByIdData?.no_of_flats, 'no_of_flats')
            handleInput(accountDetailsByIdData?.occupancy_id, 'occupancy_id')
            handleInput(accountDetailsByIdData?.security_agency_id, 'security_agency_id')
            handleInput(accountDetailsByIdData?.security_agency_name, 'security_agency_name')
            handleInput(accountDetailsByIdData?.fmc_name_id, 'fmc_name_id')
            handleInput(accountDetailsByIdData?.fmc_name, 'fmc_name')
            handleInput(accountDetailsByIdData?.society_conflict_level, 'society_conflict_level')
            handleInput(accountDetailsByIdData?.amenity_id, 'amenity_id')
            handleInput(accountDetailsByIdData?.no_of_gate_to_be_installed, 'no_of_gate_to_be_installed')
            handleInput(accountDetailsByIdData?.no_of_gate_to_be_installed_at_main_gate_society, 'no_of_gate_to_be_installed_at_main_gate_society')
            handleInput(accountDetailsByIdData?.no_of_gate_to_be_installed_at_basement, 'no_of_gate_to_be_installed_at_basement')
            handleInput(accountDetailsByIdData?.existing_setup_society_id, 'existing_setup_society_id')
            handleInput(accountDetailsByIdData?.count_of_barriers, 'count_of_barriers')
            handleInput(accountDetailsByIdData?.barrier_type_id, 'barrier_type_id')
            handleInput(accountDetailsByIdData?.barrier_make_id, 'barrier_make_id')
            handleInput(accountDetailsByIdData?.count_of_barriers_make, 'count_of_barriers_make')
            handleInput(accountDetailsByIdData?.age_of_barrier, 'age_of_barrier')
            handleInput(accountDetailsByIdData?.amc_of_current_setup, 'amc_of_current_setup')
            handleInput(accountDetailsByIdData?.boom_barrier_image, 'boom_barrier_image')
            handleInput(accountDetailsByIdData?.count_of_readers, 'count_of_readers')
            handleInput(accountDetailsByIdData?.reader_make_id, 'reader_make_id')
            handleInput(accountDetailsByIdData?.reader_age_of_setup, 'reader_age_of_setup')
            handleInput(accountDetailsByIdData?.parking_visitor_slot, 'parking_visitor_slot')
            handleInput(accountDetailsByIdData?.parking_resident_slot, 'parking_resident_slot')
            handleInput(accountDetailsByIdData?.field_executive, 'field_executive')
            images[0] = accountDetailsByIdData?.boom_barrier_image !== undefined && accountDetailsByIdData?.boom_barrier_image !== null ? accountDetailsByIdData?.boom_barrier_image : ''
            images[1] = accountDetailsByIdData?.reader_image !== undefined && accountDetailsByIdData?.reader_image !== null ? accountDetailsByIdData?.reader_image : ''
        }

    }, [accountDetailsByIdData])
    return (
        <>
            <Loader isLoading={isLoading}/>
            <div className="col-md-12">
                <div
                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                    <h1 className="h3 mb-0 text-black-100">Account Details</h1>
                </div>
                <div className="card-body  bg-white">
                    <div className="user">
                        <div className="form-group row">
                            <div className="col-sm-6 float-field mt-1">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           handleInput(e.target.value, 'client_name')
                                       }}
                                       required
                                       value={inputList[0]?.client_name}
                                       disabled={isView}
                                />
                                <label className="large-label float-lb">
                                    Business Name <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            {/*<div className="col-sm-6 float-field mt-1">*/}
                            {/*    <select className="form-control form-control-user" onChange={(e) => {*/}
                            {/*        setSocietyNameId(e.target.value)*/}
                            {/*    }} required>*/}
                            {/*        <option value="">Select Society Type</option>*/}
                            {/*        {dropdownValue?.society_type.map((val) => {*/}
                            {/*            return (*/}
                            {/*                <option value={val?.id}>{val.name}</option>*/}
                            {/*            )*/}
                            {/*        })}*/}
                            {/*    </select>*/}
                            {/*    <label className="large-label float-lb">*/}
                            {/*        Society Type <i className="bi bi-asterisk astrick-icon"></i>*/}
                            {/*    </label>*/}
                            {/*</div>*/}
                            <div className="col-sm-6 float-field mtk-025 d-mtk-1">
                                <select className="form-control form-control-user" onChange={(e) => {
                                    setLeadSource(e.target.value)
                                }} required disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                    <option value="">Select Lead Source</option>
                                    {dropdownValue?.apartment_lead_source!== undefined && dropdownValue?.apartment_lead_source.map((val) => {
                                        return (
                                            <>
                                                {(accountDetailsByIdData?.lead_source_id === val?.id) ?
                                                    <>
                                                        return (
                                                        <option value={val?.id} selected>{val.name}</option>
                                                        )
                                                    </> :
                                                    <option value={val?.id}>{val.name}</option>
                                                }
                                            </>
                                        )
                                    })}
                                </select>
                                <label className="large-label float-lb">
                                    Lead Source <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            {(parseInt(accountDetailsByIdData?.lead_source_id) === 24 || parseInt(leadSource) ===24) &&
                                <div className="col-md-6 float-field mt-sel">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        handleInput(e.target.value, 'sale_team_name')
                                    }} required >
                                        <option value="">Source of acquisition</option>
                                        {accountDetailsByIdData?.sale_team_name === "Indiamart" ?
                                            <>
                                                <option value="Indiamart" selected>Indiamart</option>
                                                <option value="Just Dial">Just Dial</option>
                                                <option value=" Park+ online leads "> Park+ online leads</option>
                                                <option value="Referral">Referral</option>
                                            </>
                                            : accountDetailsByIdData?.sale_team_name === "Just Dial" ?
                                                <>
                                                    <option value="Indiamart">Indiamart</option>
                                                    <option value="Just Dial" selected>Just Dial</option>
                                                    <option value=" Park+ online leads "> Park+ online leads</option>
                                                    <option value="Referral">Referral</option>
                                                </> :
                                                accountDetailsByIdData?.sale_team_name === "Park+ online leads" ?
                                                    <>
                                                        <option value="Indiamart">Indiamart</option>
                                                        <option value="Just Dial">Just Dial</option>
                                                        <option value="Park+ online leads" selected> Park+ online leads
                                                        </option>
                                                        <option value="Referral">Referral</option>
                                                    </> :
                                                    accountDetailsByIdData?.sale_team_name === "Referral" ?
                                                        <>
                                                            <option value="Indiamart">Indiamart</option>
                                                            <option value="Just Dial">Just Dial</option>
                                                            <option value="Park+ online leads" > Park+ online
                                                                leads
                                                            </option>
                                                            <option value="Referral" selected>Referral</option>
                                                        </>
                                                        :
                                                        <>
                                                            <option value="Indiamart">Indiamart</option>
                                                            <option value="Just Dial">Just Dial</option>
                                                            <option value="Park+ online leads"> Park+ online leads</option>
                                                            <option value="Referral">Referral</option>
                                                        </>
                                        }

                                    </select>
                                    <label className="large-label float-lb">
                                        Source of acquisition <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                            }
                            {parseInt(leadSource) === 10 &&
                                <div className="col-sm-6 float-field mt-1">
                                    <input type="text"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'field_executive')
                                           }}
                                           required
                                           value={inputList[0]?.field_executive}
                                           disabled={isView}
                                    />
                                    <label className="large-label float-lb">
                                        Field Executive <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                            }
                            {isView && parseInt(leadSource) === 11 && accountDetailsByIdData?.alternative_channel_id !== null && accountDetailsByIdData?.alternative_channel_id !== '' &&
                                <div className="col-sm-6 float-field mtk-01 d-mtk-033">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setAlternativeChannel(e.target.value)
                                    }} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                        <option value="">Select Alternate Channel</option>
                                        {dropdownValue?.alternative_channel!== undefined && dropdownValue?.alternative_channel.map((val) => {
                                            return (
                                                <>
                                                    {(accountDetailsByIdData?.alternative_channel_id === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>
                                    <label className="large-label float-lb">
                                        Alternate Channel
                                    </label>
                                </div>
                            }
                            {!isView && parseInt(leadSource) === 11 &&
                                <div className="col-sm-6 float-field mtk-01 d-mtk-033">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setAlternativeChannel(e.target.value)
                                    }} >
                                        <option value="">Select Alternate Channel</option>
                                        {dropdownValue?.alternative_channel!== undefined && dropdownValue?.alternative_channel.map((val) => {
                                            return (
                                                <>
                                                    {(accountDetailsByIdData?.alternative_channel_id === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>
                                    <label className="large-label float-lb">
                                        Alternate Channel
                                    </label>
                                </div>
                            }

                            {parseInt(leadSource) === 11 && parseInt(alternativeChannelId) === 1 && <div className="col-sm-6 float-field mt-1">
                                <select className="form-control form-control-user" onChange={(e) => {
                                    setEnterPricePartnerId(e.target.value)
                                }} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                    <option value="">Select Enterprise Partner</option>
                                    {dropdownValue?.alternative_channel!== undefined && dropdownValue?.enterprise_channel.map((val) => {
                                        return (
                                            <>
                                                {(accountDetailsByIdData?.enterprise_partner_id === val?.id) ?
                                                    <>
                                                        return (
                                                        <option value={val?.id} selected>{val.name}</option>
                                                        )
                                                    </> :
                                                    <option value={val?.id}>{val.name}</option>
                                                }
                                            </>
                                        )
                                    })}
                                </select>
                                <label className="large-label float-lb">
                                    Enterprise Partner <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>}

                            {parseInt(leadSource) === 11 && parseInt(alternativeChannelId) === 2 &&
                                <div className="col-sm-6 float-field mt-1">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setInboundChannelId(e.target.value)
                                    }} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                        <option value="">Select Inbound Channel</option>
                                        {dropdownValue?.inbound_channel!== undefined && dropdownValue?.inbound_channel.map((val) => {
                                            return (
                                                <>
                                                    {(accountDetailsByIdData?.inbound_channel_id === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>
                                    <label className="large-label float-lb">
                                        Inbound Channel <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                            }
                            {/*{(inboundChannelId === '4' || inboundChannelId === '6' || inboundChannelId === '7')  &&*/}
                            {/*    <div className="col-sm-6 float-field mt-1">*/}
                            {/*        <label className="large-label float-lb">*/}
                            {/*            Inbound Channel Name*/}
                            {/*            <input type="text"*/}
                            {/*                   className="form-control form-control-user"*/}
                            {/*                   placeholder="Enter Inbound Channel Name"*/}
                            {/*                   onChange={(e) => {*/}
                            {/*                       handleInput(e.target.value, 'inbound_channel_name')*/}
                            {/*                   }}*/}
                            {/*                   required*/}
                            {/*            />*/}
                            {/*        </label>*/}
                            {/*    </div>*/}
                            {/*}*/}

                            {parseInt(leadSource) === 11 && parseInt(alternativeChannelId) === 3 && <div className="col-sm-6 float-field mt-1">
                                <select className="form-control form-control-user" onChange={(e) => {
                                    setDistributePartnerId(e.target.value)
                                }} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                    <option value="">Select Distribution Partner</option>
                                    {dropdownValue?.distribution_partner!== undefined && dropdownValue?.distribution_partner.map((val) => {
                                        return (
                                            <>
                                                {(accountDetailsByIdData?.distribute_channel_id === val?.id) ?
                                                    <>
                                                        return (
                                                        <option value={val?.id} selected>{val.name}</option>
                                                        )
                                                    </> :
                                                    <option value={val?.id}>{val.name}</option>
                                                }
                                            </>
                                        )
                                    })}
                                </select>
                                <label className="large-label float-lb">
                                    Distribution Partner <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-12">
                <div
                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                    <h1 className="h3 mb-0 text-black-100">Location Details</h1>
                </div>
                <div className="card-body  bg-white">
                    <div className="user">
                        <div className="form-group row">
                            {/*<div className="col-sm-6 float-field mt-1">*/}
                            {/*    <input type="text"*/}
                            {/*           className="form-control form-control-user"*/}
                            {/*           placeholder=" "*/}
                            {/*           onChange={(e) => {*/}
                            {/*               handleInput(e.target.value, 'address_2')*/}
                            {/*           }}*/}
                            {/*           value={inputList[0]?.address_2}*/}
                            {/*    />*/}
                            {/*    <label className="large-label float-lb">*/}
                            {/*        Address Line 2*/}
                            {/*    </label>*/}
                            {/*</div>*/}
                            <SearchLocation
                                handleCurrentLocationBlur={handleCurrentLocationBlur}
                                isError={isInputError.crl}
                                value={optOption.currentLocation}
                                handleCurrentLocationChange={handleCurrentLocationChange}
                                isView={isView}
                                label={"Society Location"}
                                setPincodeValue={setPincodeValue}
                            />
                            <div className="col-sm-6 float-field d-mtk-03">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(val) => {
                                           handleInput(val, 'latitude')
                                       }}
                                       value={lat}
                                       required
                                       disabled={isView}
                                />
                                <label className="large-label float-lb">
                                    Latitude <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-sm-6 float-field d-mtk-1">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(val) => {
                                           handleInput(val, 'longitude')
                                       }}
                                       value={long}
                                       required
                                       disabled={isView}
                                />
                                <label className="large-label float-lb">
                                    Longitude <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-sm-6 float-field d-mtk-1">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           handleInput(e.target.value, 'address_1')
                                       }}
                                       required
                                       value={inputList[0].address_1}
                                       disabled={isView}
                                />
                                <label className="large-label float-lb">
                                    Address <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-sm-6 float-field mtk-025 d-mtk-1">
                                <input type="number"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           setPincodeValue(e.target.value, 'pincode')
                                       }}
                                       required
                                       // value={inputList[0]?.pincode}
                                       value={pincodeValue}
                                       disabled={isView}
                                />
                                <label className="large-label float-lb">
                                    Pincode <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-sm-6 float-field d-mtk-1">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           handleInput(pincodeData?.geo_city_id, 'geographical_city_id')
                                       }}
                                       disabled
                                       value={pincodeData?.city_name !== undefined ? pincodeData?.city_name : ''}
                                       required
                                />
                                <label className="large-label float-lb">
                                    Geographical City <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-sm-6 float-field d-mtk-1">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           handleInput(pincodeData?.geo_state_id, 'geographical_state_id')
                                       }}
                                       disabled
                                       value={pincodeData?.state_name !== undefined ? pincodeData?.state_name : ''}
                                       required
                                />
                                <label className="large-label float-lb">
                                    Geographical State <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            {/*<div className="col-sm-6 float-field mtk-025 d-mtk-1">*/}
                            {/*    <input type="text"*/}
                            {/*           className="form-control form-control-user"*/}
                            {/*           placeholder=" "*/}
                            {/*           onChange={(e) => {*/}
                            {/*               handleInput(e.target.value, 'state_id')*/}
                            {/*               setStateId(stateRegionDetails?.state_id)*/}
                            {/*           }}*/}
                            {/*           required*/}
                            {/*           value={state}*/}
                            {/*           disabled*/}
                            {/*    />*/}
                            {/*    <label className="large-label float-lb">*/}
                            {/*        State <i className="bi bi-asterisk astrick-icon"></i>*/}
                            {/*    </label>*/}
                            {/*</div>*/}
                            {/*<div className="col-sm-6 float-field mtk-025 d-mtk-1">*/}
                            {/*    <input type="text"*/}
                            {/*           className="form-control form-control-user"*/}
                            {/*           placeholder=" "*/}
                            {/*           onChange={(e) => {*/}
                            {/*               handleInput(e.target.value, 'region')*/}
                            {/*               setRegionId(stateRegionDetails?.region_id)*/}
                            {/*           }}*/}
                            {/*           value={regionName}*/}
                            {/*           required*/}
                            {/*           disabled*/}
                            {/*    />*/}
                            {/*    <label className="large-label float-lb">*/}
                            {/*        Region <i className="bi bi-asterisk astrick-icon"></i>*/}
                            {/*    </label>*/}
                            {/*</div>*/}
                            <div className="col-sm-6 float-field mtk-025 d-mtk-1">
                                <select className="form-control form-control-user"
                                        onChange={(e) => setCityId(e.target.value)} required disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                    <option value="">Select City</option>
                                    {locationCity.map((val) => {
                                        return (
                                            <>
                                                {(parseInt(accountDetailsByIdData?.city_id) === val?.id) ?
                                                    <>
                                                        return (
                                                        <option value={val?.id} selected>{val.name}</option>
                                                        )
                                                    </> :
                                                    <option value={val?.id}>{val.name}</option>
                                                }
                                            </>
                                        )
                                    })}
                                </select>
                                <label className="large-label float-lb">
                                    City <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-sm-6 float-field mtk-025 d-mtk-1">
                                <select className="form-control form-control-user"
                                        onChange={(e) => setZoneId(e.target.value)} required disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                    <option value="">Select Zone</option>
                                    {zones.map((val) => {
                                        return (
                                            <>
                                                {(parseInt(accountDetailsByIdData?.zone_id) === val?.id) ?
                                                    <>
                                                        return (
                                                        <option value={val?.id} selected>{val.name}</option>
                                                        )
                                                    </> :
                                                    <option value={val?.id}>{val.name}</option>
                                                }
                                            </>
                                        )
                                    })}
                                </select>
                                <label className="large-label float-lb">
                                    Zone <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-sm-6 float-field mtk-05 d-mtk-1">
                                <select className="form-control form-control-user"
                                        onChange={(e) => setAreaId(e.target.value)} required disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                    <option value="">Select Area/Sector</option>
                                    {areas.map((val) => {
                                        return (
                                            <>
                                                {(parseInt(accountDetailsByIdData?.area_id) === val?.id) ?
                                                    <>
                                                        return (
                                                        <option value={val?.id} selected>{val.name}</option>
                                                        )
                                                    </> :
                                                    <option value={val?.id}>{val.name}</option>
                                                }
                                            </>
                                        )
                                    })}
                                </select>
                                <label className="large-label float-lb">
                                    Area/Sector <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-12">
                <div
                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                    <h1 className="h3 mb-0 text-black-100">Others Details</h1>
                </div>
                <div className="card-body bg-white">
                    <div className="user">
                        <div className="form-group row">
                            <div className="col-sm-6 float-field mtk-1">
                                <input type="number"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           handleInput(e.target.value, 'parking_resident_slot')
                                       }}
                                       value={inputList[0]?.parking_resident_slot}
                                    // value={accountDetailsByIdData?.branch_name}
                                       disabled={isView}
                                />
                                <label className="large-label float-lb">
                                    Parking Resident Slot
                                </label>
                            </div>
                            <div className="col-sm-6 float-field mtk-025 d-mtk-03">
                                <input type="number"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           handleInput(e.target.value, 'parking_visitor_slot')
                                       }}
                                       value={inputList[0]?.parking_visitor_slot}
                                    // value={accountDetailsByIdData?.branch_name}
                                       disabled={isView}
                                />
                                <label className="large-label float-lb">
                                    Parking Visitor Slot
                                </label>
                            </div>
                            {/*{!isView &&*/}
                            {/*    <div className="col-sm-6 float-field mtk-01 d-mtk-1">*/}
                            {/*        <select className="form-control form-control-user"*/}
                            {/*                onChange={(e) => setParkingSlotId(e.target.value)} >*/}
                            {/*            <option value="">Select Parking Slot Category</option>*/}
                            {/*            {dropdownValue?.parking_slot!== undefined && dropdownValue?.parking_slot.map((val) => {*/}
                            {/*                return (*/}
                            {/*                    <>*/}
                            {/*                        {(parseInt(accountDetailsByIdData?.parking_slots) === val?.id) ?*/}
                            {/*                            <>*/}
                            {/*                                return (*/}
                            {/*                                <option value={val?.id} selected>{val.name}</option>*/}
                            {/*                                )*/}
                            {/*                            </> :*/}
                            {/*                            <option value={val?.id}>{val.name}</option>*/}
                            {/*                        }*/}
                            {/*                    </>*/}
                            {/*                )*/}
                            {/*            })}*/}
                            {/*        </select>*/}
                            {/*        <label className="large-label float-lb">*/}
                            {/*            Parking Slot Category*/}
                            {/*        </label>*/}
                            {/*    </div>*/}
                            {/*}*/}
                            {/*{isView && accountDetailsByIdData?.parking_slot_type_id!== null && accountDetailsByIdData?.parking_slot_type_id !== '' &&*/}
                            {/*    <div className="col-sm-6 float-field mtk-01 d-mtk-1">*/}
                            {/*        <select className="form-control form-control-user"*/}
                            {/*                onChange={(e) => setParkingSlotId(e.target.value)} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>*/}
                            {/*            <option value="">Select Parking Slot Category</option>*/}
                            {/*            {dropdownValue?.parking_slot!== undefined && dropdownValue?.parking_slot.map((val) => {*/}
                            {/*                return (*/}
                            {/*                    <>*/}
                            {/*                        {(parseInt(accountDetailsByIdData?.parking_slot_type_id) === val?.id) ?*/}
                            {/*                            <>*/}
                            {/*                                return (*/}
                            {/*                                <option value={val?.id} selected>{val.name}</option>*/}
                            {/*                                )*/}
                            {/*                            </> :*/}
                            {/*                            <option value={val?.id}>{val.name}</option>*/}
                            {/*                        }*/}
                            {/*                    </>*/}
                            {/*                )*/}
                            {/*            })}*/}
                            {/*        </select>*/}
                            {/*        <label className="large-label float-lb">*/}
                            {/*            Parking Slot Category*/}
                            {/*        </label>*/}
                            {/*    </div>*/}
                            {/*}*/}

                            {/*{parseInt(parkingSlotId) !== '' && parkingSlotId !== null && !isNaN(parkingSlotId) &&*/}
                            {/*    <div className="col-sm-6 float-field mtk-1 d-mtk-2">*/}
                            {/*        <input type="number"*/}
                            {/*               className="form-control form-control-user"*/}
                            {/*               placeholder=" "*/}
                            {/*               onChange={(e) => {*/}
                            {/*                   handleInput(e.target.value, 'total_parking_slot')*/}
                            {/*               }}*/}
                            {/*               value={inputList[0]?.total_parking_slot}*/}
                            {/*               disabled={isView}*/}
                            {/*               // value={accountDetailsByIdData?.total_parking_slot}*/}

                            {/*        />*/}
                            {/*        <label className="large-label float-lb">*/}
                            {/*            Total Parking Slot*/}
                            {/*        </label>*/}
                            {/*    </div>*/}
                            {/*}*/}
                            {isView && inputList[0]?.total_maintenance_per_month !== 0 &&
                                <div className="col-sm-6 float-field mt-1 d-mtk-1">
                                    <input type="number"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'total_maintenance_per_month')
                                           }}
                                           value={inputList[0]?.total_maintenance_per_month}
                                           disabled={isView}
                                        // value={accountDetailsByIdData?.total_maintenance_per_month}
                                    />
                                    <label className="large-label float-lb">
                                        Total maintenance per month
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-sm-6 float-field mt-1 d-mtk-1">
                                    <input type="number"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'total_maintenance_per_month')
                                           }}
                                           value={inputList[0]?.total_maintenance_per_month}
                                           disabled={isView}
                                        // value={accountDetailsByIdData?.total_maintenance_per_month}
                                    />
                                    <label className="large-label float-lb">
                                        Total maintenance per month
                                    </label>
                                </div>
                            }
                            {isView && accountDetailsByIdData?.bank_account_name_id !== null && accountDetailsByIdData?.bank_account_name_id !== '' &&
                                <div className="col-sm-6 float-field mtk-05 d-mtk-03">
                                    <select className="form-control form-control-user"
                                            onChange={(e) => setBankAccountName(e.target.value)} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                        <option value="">Select Bank Account Name</option>
                                        {dropdownValue?.bank_name!== undefined && dropdownValue?.bank_name.map((val) => {
                                            return (
                                                <>
                                                    {(parseInt(accountDetailsByIdData?.bank_account_name_id) === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>
                                    <label className="large-label float-lb"
                                    >
                                        Bank Account Name
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-sm-6 float-field mtk-05 d-mtk-03">
                                    <select className="form-control form-control-user"
                                            onChange={(e) => setBankAccountName(e.target.value)}>
                                        <option value="">Select Bank Account Name</option>
                                        {dropdownValue?.bank_name!== undefined && dropdownValue?.bank_name.map((val) => {
                                            return (
                                                <>
                                                    {(parseInt(accountDetailsByIdData?.bank_account_name_id) === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>
                                    <label className="large-label float-lb"
                                    >
                                        Bank Account Name
                                    </label>
                                </div>
                            }
                            {isView && inputList[0]?.branch_name !== '' && inputList[0]?.branch_name !== null &&
                                <div className="col-sm-6 float-field mtk-1">
                                    <input type="text"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'branch_name')
                                           }}
                                           value={inputList[0]?.branch_name}
                                        // value={accountDetailsByIdData?.branch_name}
                                        disabled={isView}
                                    />
                                    <label className="large-label float-lb">
                                        Branch
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-sm-6 float-field mtk-1">
                                    <input type="text"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'branch_name')
                                           }}
                                           value={inputList[0]?.branch_name}
                                        // value={accountDetailsByIdData?.branch_name}

                                    />
                                    <label className="large-label float-lb">
                                        Branch
                                    </label>
                                </div>
                            }
                            {isView && inputList[0]?.no_of_flats !== '' && inputList[0]?.no_of_flats !== null &&
                                <div className="col-sm-6 float-field mt-1">
                                    <input type="number"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'no_of_flats')
                                           }}
                                           value={inputList[0]?.no_of_flats}
                                        // value={accountDetailsByIdData?.no_of_flats}
                                        disabled={isView}
                                    />
                                    <label className="large-label float-lb">
                                        Total No of Flats
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-sm-6 float-field mt-1">
                                    <input type="number"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'no_of_flats')
                                           }}
                                           value={inputList[0]?.no_of_flats}
                                        // value={accountDetailsByIdData?.no_of_flats}
                                    />
                                    <label className="large-label float-lb">
                                        Total No of Flats
                                    </label>
                                </div>
                            }
                            {isView && accountDetailsByIdData?.occupancy_id !== null && accountDetailsByIdData?.occupancy_id !== '' &&
                                <div className="col-sm-6 float-field mtk-05 d-mtk-03">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setOccupancyId(e.target.value)
                                    }} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                        <option value="">Select Occupancy</option>
                                        {dropdownValue?.occupancy!== undefined && dropdownValue?.occupancy.map((val) => {
                                            return (
                                                <>
                                                    {(parseInt(accountDetailsByIdData?.occupancy_id) === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>
                                    <label className="large-label float-lb">
                                        Occupancy
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-sm-6 float-field mtk-05 d-mtk-03">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setOccupancyId(e.target.value)
                                    }} >
                                        <option value="">Select Occupancy</option>
                                        {dropdownValue?.occupancy!== undefined && dropdownValue?.occupancy.map((val) => {
                                            return (
                                                <>
                                                    {(parseInt(accountDetailsByIdData?.occupancy_id) === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>
                                    <label className="large-label float-lb">
                                        Occupancy
                                    </label>
                                </div>
                            }
                            {isView && accountDetailsByIdData?.security_agency_id !== null && accountDetailsByIdData?.security_agency_id !== '' &&
                                <div className="col-sm-6 float-field mtk-01 d-mtk-1">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setSecurityAgencyId(e.target.value)
                                    }} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                        <option value="">Select Security Agency</option>
                                        {dropdownValue?.security_agency!== undefined && dropdownValue?.security_agency.map((val) => {
                                            return (
                                                <>
                                                    {(parseInt(accountDetailsByIdData?.security_agency_id) === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>
                                    <label className="large-label float-lb">
                                        Security Agency
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-sm-6 float-field mtk-01 d-mtk-1">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setSecurityAgencyId(e.target.value)
                                    }}>
                                        <option value="">Select Security Agency</option>
                                        {dropdownValue?.security_agency!== undefined && dropdownValue?.security_agency.map((val) => {
                                            return (
                                                <>
                                                    {(parseInt(accountDetailsByIdData?.security_agency_id) === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>
                                    <label className="large-label float-lb">
                                        Security Agency
                                    </label>
                                </div>
                            }
                            {parseInt(securityAgencyId) === 4 &&
                                <div className="col-sm-6 float-field mt-1">
                                    <input type="text"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'security_agency_name')
                                           }}
                                           required
                                           // value={accountDetailsByIdData?.security_agency_name}
                                           value={inputList[0]?.security_agency_name}
                                           disabled={isView}
                                    />
                                    <label className="large-label float-lb">
                                        Security Agency Name <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                            }
                            {isView && accountDetailsByIdData?.vms_id !== null && accountDetailsByIdData?.vms_id !== '' &&
                                <div className="col-sm-6 float-field mt-3 d-mtk-2">
                                    <select className="form-control form-control-user"
                                            onChange={(e) => setVmsId(e.target.value)} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                        <option value="">Select VMS</option>
                                        {dropdownValue?.vms_type!== undefined && dropdownValue?.vms_type.map((val) => {
                                            return (
                                                <>
                                                    {(parseInt(accountDetailsByIdData?.vms_id) === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>
                                    <label className="large-label float-lb">
                                        VMS
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-sm-6 float-field mt-3 d-mtk-2">
                                    <select className="form-control form-control-user"
                                            onChange={(e) => setVmsId(e.target.value)}>
                                        <option value="">Select VMS</option>
                                        {dropdownValue?.vms_type!== undefined && dropdownValue?.vms_type.map((val) => {
                                            return (
                                                <>
                                                    {(parseInt(accountDetailsByIdData?.vms_id) === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>
                                    <label className="large-label float-lb">
                                        VMS
                                    </label>
                                </div>
                            }
                            {isView && accountDetailsByIdData?.fmc_name_id !== null && accountDetailsByIdData?.fmc_name_id !== '' &&
                                <div className="col-sm-6 float-field mt-3 d-mtk-2">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setFmcName(e.target.value)
                                    }} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                        <option value="">Select FMC Name</option>
                                        {dropdownValue?.apartment_fmc_name!== undefined && dropdownValue?.apartment_fmc_name.map((val) => {
                                            return (
                                                <>
                                                    {(parseInt(accountDetailsByIdData?.fmc_name_id) === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>
                                    <label className="large-label float-lb">
                                        FMC name
                                    </label>
                                </div>
                            }

                            {!isView &&
                                <div className="col-sm-6 float-field mt-3 d-mtk-2">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setFmcName(e.target.value)
                                    }} >
                                        <option value="">Select FMC Name</option>
                                        {dropdownValue?.apartment_fmc_name!== undefined && dropdownValue?.apartment_fmc_name.map((val) => {
                                            return (
                                                <>
                                                    {(parseInt(accountDetailsByIdData?.fmc_name_id) === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>
                                    <label className="large-label float-lb">
                                        FMC name
                                    </label>
                                </div>
                            }

                            {parseInt(fmcName) === 16 &&
                                <div className="col-sm-6 float-field mt-3">
                                    <input type="text"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'fmc_name')
                                           }}
                                           required
                                           value={inputList[0]?.fmc_name}
                                           disabled={isView}
                                           // value={accountDetailsByIdData?.fmc_name}
                                    />
                                    <label className="large-label float-lb">
                                        Fmc Name <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                            }

                            {isView && accountDetailsByIdData?.society_conflict_level!== null && accountDetailsByIdData?.society_conflict_level !=='' &&
                                <div className="col-sm-6 float-field mt-3">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setSocietyConflictLevel(e.target.value)
                                    }} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                        <option value="">Select Society Conflict Level</option>
                                        {accountDetailsByIdData?.society_conflict_level === 'Comprehensive' ?
                                            <>
                                                <option value="Comprehensive" selected>Comprehensive</option>
                                                <option value="Non-Comprehensive">Non-Comprehensive</option>
                                                <option value="No">No</option>
                                            </> :
                                            accountDetailsByIdData?.society_conflict_level === 1 ?
                                                <>
                                                    <option value="1" selected>1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                </> : accountDetailsByIdData?.society_conflict_level === 2 ?
                                                    <>
                                                        <option value="1">1</option>
                                                        <option value="2" selected>2</option>
                                                        <option value="3">3</option>
                                                        <option value="4">4</option>
                                                        <option value="5">5</option>
                                                    </> : accountDetailsByIdData?.society_conflict_level === 3 ?
                                                        <>
                                                            <option value="1">1</option>
                                                            <option value="2">2</option>
                                                            <option value="3" selected>3</option>
                                                            <option value="4">4</option>
                                                            <option value="5">5</option>
                                                        </> : accountDetailsByIdData?.society_conflict_level === 4 ?
                                                            <>
                                                                <option value="1">1</option>
                                                                <option value="2" selected>2</option>
                                                                <option value="3">3</option>
                                                                <option value="4" selected>4</option>
                                                                <option value="5">5</option>
                                                            </> : accountDetailsByIdData?.society_conflict_level === 5 ?
                                                                <>
                                                                    <option value="1">1</option>
                                                                    <option value="2" selected>2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4">4</option>
                                                                    <option value="5" selected>5</option>
                                                                </> :
                                                                <>
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4">4</option>
                                                                    <option value="5">5</option>
                                                                </>
                                        }

                                    </select>
                                    <label className="large-label float-lb">
                                        Society Conflict Level
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-sm-6 float-field mt-3">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setSocietyConflictLevel(e.target.value)
                                    }}>
                                        <option value="">Select Society Conflict Level</option>
                                        {accountDetailsByIdData?.society_conflict_level === 'Comprehensive' ?
                                            <>
                                                <option value="Comprehensive" selected>Comprehensive</option>
                                                <option value="Non-Comprehensive">Non-Comprehensive</option>
                                                <option value="No">No</option>
                                            </> :
                                            accountDetailsByIdData?.society_conflict_level === 1 ?
                                                <>
                                                    <option value="1" selected>1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                </> : accountDetailsByIdData?.society_conflict_level === 2 ?
                                                    <>
                                                        <option value="1">1</option>
                                                        <option value="2" selected>2</option>
                                                        <option value="3">3</option>
                                                        <option value="4">4</option>
                                                        <option value="5">5</option>
                                                    </> : accountDetailsByIdData?.society_conflict_level === 3 ?
                                                        <>
                                                            <option value="1">1</option>
                                                            <option value="2">2</option>
                                                            <option value="3" selected>3</option>
                                                            <option value="4">4</option>
                                                            <option value="5">5</option>
                                                        </> : accountDetailsByIdData?.society_conflict_level === 4 ?
                                                            <>
                                                                <option value="1">1</option>
                                                                <option value="2" selected>2</option>
                                                                <option value="3">3</option>
                                                                <option value="4" selected>4</option>
                                                                <option value="5">5</option>
                                                            </> : accountDetailsByIdData?.society_conflict_level === 5 ?
                                                                <>
                                                                    <option value="1">1</option>
                                                                    <option value="2" selected>2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4">4</option>
                                                                    <option value="5" selected>5</option>
                                                                </> :
                                                                <>
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4">4</option>
                                                                    <option value="5">5</option>
                                                                </>
                                        }

                                    </select>
                                    <label className="large-label float-lb">
                                        Society Conflict Level
                                    </label>
                                </div>
                            }
                            {isView && accountDetailsByIdData?.amenity_id !== null && accountDetailsByIdData?.amenity_id !=='' &&
                                <div className="col-sm-6 float-field mt-3">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setAmenitiesId(e.target.value)
                                    }} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                        <option value="">Select Other Amenities</option>
                                        {dropdownValue?.amenities!== undefined && dropdownValue?.amenities.map((val) => {
                                            return (
                                                <>
                                                    {(parseInt(accountDetailsByIdData?.amenity_id) === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>
                                    <label className="large-label float-lb">
                                        Other Amenities
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-sm-6 float-field mt-3">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setAmenitiesId(e.target.value)
                                    }}>
                                        <option value="">Select Other Amenities</option>
                                        {dropdownValue?.amenities!== undefined && dropdownValue?.amenities.map((val) => {
                                            return (
                                                <>
                                                    {(parseInt(accountDetailsByIdData?.amenity_id) === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>
                                    <label className="large-label float-lb">
                                        Other Amenities
                                    </label>
                                </div>
                            }
                            {isView && inputList[0]?.no_of_gate_to_be_installed !== '' && inputList[0]?.no_of_gate_to_be_installed !== null &&
                                <div className="col-sm-6 float-field mtk-075 d-mtk-2">
                                    <input type="number"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'no_of_gate_to_be_installed')
                                           }}
                                           value={inputList[0]?.no_of_gate_to_be_installed}
                                        // value={accountDetailsByIdData?.no_of_gate_to_be_installed}
                                           disabled={isView}
                                    />
                                    <label className="large-label float-lb">
                                        Maximum no of Gates
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-sm-6 float-field mtk-075 d-mtk-2">
                                    <input type="number"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'no_of_gate_to_be_installed')
                                           }}
                                           value={inputList[0]?.no_of_gate_to_be_installed}
                                        // value={accountDetailsByIdData?.no_of_gate_to_be_installed}
                                    />
                                    <label className="large-label float-lb">
                                        Maximum no of Gates
                                    </label>
                                </div>
                            }
                            {isView && inputList[0]?.no_of_gate_to_be_installed_at_main_gate_society!== '' &&  inputList[0]?.no_of_gate_to_be_installed_at_main_gate_society !== null &&
                                <div className="col-sm-6 float-field mtk-025 d-mtk-1">
                                    <input type="number"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'no_of_gate_to_be_installed_at_main_gate_society')
                                           }}
                                           value={inputList[0]?.no_of_gate_to_be_installed_at_main_gate_society}
                                           disabled={isView}
                                        // value={accountDetailsByIdData?.no_of_gate_to_be_installed_at_main_gate_society}
                                    />
                                    <label className="large-label float-lb">
                                        Number of gates for main gate
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-sm-6 float-field mtk-025 d-mtk-2">
                                    <input type="number"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'no_of_gate_to_be_installed_at_main_gate_society')
                                           }}
                                           value={inputList[0]?.no_of_gate_to_be_installed_at_main_gate_society}
                                           disabled={isView}
                                        // value={accountDetailsByIdData?.no_of_gate_to_be_installed_at_main_gate_society}
                                    />
                                    <label className="large-label float-lb">
                                        Number of gates for main gate
                                    </label>
                                </div>
                            }
                            {isView && inputList[0]?.no_of_gate_to_be_installed_at_basement !=='' && inputList[0]?.no_of_gate_to_be_installed_at_basement !== null &&
                                <div className="col-sm-6 float-field mt-1 d-mtk-2">
                                    <input type="number"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'no_of_gate_to_be_installed_at_basement')
                                           }}
                                           value={inputList[0]?.no_of_gate_to_be_installed_at_basement}
                                           disabled={isView}
                                        // value={accountDetailsByIdData?.no_of_gate_to_be_installed_at_basement}

                                    />
                                    <label className="large-label float-lb">
                                        Number of gates for Basement
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-sm-6 float-field mt-1">
                                    <input type="number"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'no_of_gate_to_be_installed_at_basement')
                                           }}
                                           value={inputList[0]?.no_of_gate_to_be_installed_at_basement}
                                        // value={accountDetailsByIdData?.no_of_gate_to_be_installed_at_basement}

                                    />
                                    <label className="large-label float-lb">
                                        Number of gates for Basement
                                    </label>
                                </div>
                            }

                            {isView && accountDetailsByIdData?.existing_setup_society_id !== null && accountDetailsByIdData?.existing_setup_society_id !=='' &&
                                <div className="col-sm-6 float-field mtk-05 d-mtk-1">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setExistingSetupSocietyYes(e.target.value)
                                    }} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                        <option value="">Select Existing Setup</option>
                                        {dropdownValue?.existing_setup_society!== undefined && dropdownValue?.existing_setup_society.map((val) => {
                                            return (
                                                <>
                                                    {(parseInt(accountDetailsByIdData?.existing_setup_society_id) === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>
                                    <label className="large-label float-lb">
                                        Existing Setup
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-sm-6 float-field mtk-05 d-mtk-1">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setExistingSetupSocietyYes(e.target.value)
                                    }}>
                                        <option value="">Select Existing Setup</option>
                                        {dropdownValue?.existing_setup_society!== undefined && dropdownValue?.existing_setup_society.map((val) => {
                                            return (
                                                <>
                                                    {(parseInt(accountDetailsByIdData?.existing_setup_society_id) === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>
                                    <label className="large-label float-lb">
                                        Existing Setup
                                    </label>
                                </div>
                            }

                            {(parseInt(existingSetupSocietyYes) === 1 || parseInt(existingSetupSocietyYes) === 2) &&
                                <>
                                    <div className="col-sm-6 float-field mt-1">
                                        <input type="number"
                                               className="form-control form-control-user"
                                               placeholder=" "
                                               onChange={(e) => {
                                                   handleInput(e.target.value, 'count_of_barriers')
                                               }}
                                               required
                                               // value={accountDetailsByIdData?.count_of_barriers}
                                               value={inputList[0]?.count_of_barriers}
                                               disabled={isView}
                                        />
                                        <label className="large-label float-lb">
                                            Count of Barriers <i className="bi bi-asterisk astrick-icon"></i>
                                        </label>
                                    </div>
                                    <div className="col-sm-6 float-field mt-1">
                                        <select className="form-control form-control-user" onChange={(e) => {
                                            setBarrierTypeId(e.target.value)
                                        }} required disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                            <option value="">Select Barrier Type</option>
                                            {dropdownValue?.barrier_type!== undefined && dropdownValue?.barrier_type.map((val) => {
                                                return (
                                                    <>
                                                        {(parseInt(accountDetailsByIdData?.barrier_type_id) === val?.id) ?
                                                            <>
                                                                return (
                                                                <option value={val?.id} selected>{val.name}</option>
                                                                )
                                                            </> :
                                                            <option value={val?.id}>{val.name}</option>
                                                        }
                                                    </>
                                                )
                                            })}
                                        </select>
                                        <label className="large-label float-lb">
                                            Barrier Type <i className="bi bi-asterisk astrick-icon"></i>
                                        </label>
                                    </div>
                                    <div className="col-sm-6 float-field mt-1">
                                        <select className="form-control form-control-user" onChange={(e) => {
                                            setBarrierMake(e.target.value)
                                        }} required disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                            <option value="">Select Barrier Make</option>
                                            {dropdownValue?.barrier_make!== undefined && dropdownValue?.barrier_make.map((val) => {
                                                return (
                                                    <>
                                                        {(parseInt(accountDetailsByIdData?.barrier_make_id) === val?.id) ?
                                                            <>
                                                                return (
                                                                <option value={val?.id} selected>{val.name}</option>
                                                                )
                                                            </> :
                                                            <option value={val?.id}>{val.name}</option>
                                                        }
                                                    </>
                                                )
                                            })}
                                        </select>
                                        <label className="large-label float-lb">
                                            Barrier Make <i className="bi bi-asterisk astrick-icon"></i>
                                        </label>
                                    </div>
                                    {parseInt(barrierMake) === 5 &&
                                        <div className="col-sm-6 float-field mt-1">
                                            <input type="text"
                                                   className="form-control form-control-user"
                                                   placeholder=" "
                                                   onChange={(e) => {
                                                       handleInput(e.target.value, 'count_of_barriers_make')
                                                   }}
                                                   required
                                                   value={accountDetailsByIdData?.count_of_barriers_make}
                                                   disabled={isView}
                                            />
                                            <label className="large-label float-lb">
                                                Count of Barriers Make <i className="bi bi-asterisk astrick-icon"></i>
                                            </label>
                                        </div>
                                    }
                                    <div className="col-sm-6 float-field mt-1">
                                        <select className="form-control form-control-user" onChange={(e) => {
                                            setAgeOfBarrier(e.target.value)
                                        }} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                            <option value="">Select Age Of Barrier</option>
                                            {dropdownValue?.age_of_barrier!== undefined && dropdownValue?.age_of_barrier.map((val) => {
                                                return (
                                                    <>
                                                        {(parseInt(accountDetailsByIdData?.age_of_barrier) === val?.id) ?
                                                            <>
                                                                return (
                                                                <option value={val?.id} selected>{val.name}</option>
                                                                )
                                                            </> :
                                                            <option value={val?.id}>{val.name}</option>
                                                        }
                                                    </>
                                                )
                                            })}
                                        </select>
                                        <label className="large-label float-lb">
                                            Age Of Barrier
                                        </label>
                                    </div>

                                    <div className="col-sm-6 float-field mt-1">
                                        <select className="form-control form-control-user" onChange={(e) => {
                                            setAmcOfCurrentSetup(e.target.value)
                                        }} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                            <option value="">Select AMC of Current Setup</option>
                                            {accountDetailsByIdData?.amc_of_current_setup === 'Comprehensive' ?
                                                <>
                                                    <option value="Comprehensive" selected>Comprehensive</option>
                                                    <option value="Non-Comprehensive">Non-Comprehensive</option>
                                                    <option value="No">No</option>
                                                </> :
                                                accountDetailsByIdData?.amc_of_current_setup === 'Non-Comprehensive' ?
                                                    <>
                                                        <option value="Comprehensive" selected>Comprehensive</option>
                                                        <option value="Non-Comprehensive" selected>Non-Comprehensive
                                                        </option>
                                                        <option value="No">No</option>
                                                    </> : accountDetailsByIdData?.amc_of_current_setup === 'No' ?
                                                        <>
                                                            <option value="Comprehensive">Comprehensive</option>
                                                            <option value="Non-Comprehensive">Non-Comprehensive</option>
                                                            <option value="No" selected>No</option>
                                                        </> :
                                                        <>
                                                            <option value="Comprehensive">Comprehensive</option>
                                                            <option value="Non-Comprehensive">Non-Comprehensive</option>
                                                            <option value="No">No</option>
                                                        </>
                                            }
                                        </select>
                                        <label className="large-label float-lb">
                                            AMC of Current Setup
                                        </label>
                                    </div>

                                    {isView &&
                                        <img src={images[0]} className="mt-1"/>
                                    }
                                    {!isView &&
                                        <div className="col-sm-6 mt-4 mb-3">
                                            <FileUpload
                                                id={"addAttachment" + 1}
                                                accept=".png,.jpg,.jpeg"
                                                documentUploadUrl={documentUploadUrlPublic}
                                                documentUrlData={documentUrlDataPublic}
                                                onChange={(val) => {
                                                    handleInput(val, 'boom_barrier_image')
                                                    if(val!==''){
                                                        setBoomBarrierImage(val)
                                                    }
                                                }}
                                                prefilledFilename={images[0]? "Uploaded Image" : ''}
                                                dataObject={images}
                                                variable={0}
                                                reset={images ===undefined && images[0] === undefined}
                                            >
                                                Boom Barrier Pic
                                            </FileUpload>


                                        </div>
                                    }
                                </>
                            }
                            {parseInt(existingSetupSocietyYes) === 2 &&
                                <>
                                    {isView &&
                                        <img src={images[1] } className="mt-1"/>
                                    }
                                    {!isView &&
                                        <div className="col-sm-6 mt-4 mb-3">
                                            <FileUpload
                                                id={"addAttachment" + 2}
                                                accept=".png,.jpg,.jpeg"
                                                documentUploadUrl={documentUploadUrlPublic}
                                                documentUrlData={documentUrlDataPublic}
                                                onChange={(val) => {
                                                    handleInput(val, 'reader_image')
                                                    if(val!==''){
                                                        setReaderImages(val)
                                                    }
                                                }}
                                                prefilledFilename={images[1]  ? "Uploaded Image" : ''}
                                                dataObject={images}
                                                variable={1}
                                                reset={images ===undefined && images[1] === undefined}
                                            >
                                                Reader Pic
                                            </FileUpload>
                                            <img src={images[1] } className="mt-1"/>
                                        </div>
                                    }
                                    <div className="col-sm-6 float-field mt-1">
                                        <input type="text"
                                               className="form-control form-control-user"
                                               placeholder=""
                                               onChange={(e) => {
                                                   handleInput(e.target.value, 'count_of_readers')
                                               }}
                                               value={inputList[0]?.count_of_readers}
                                               disabled={isView}
                                        />
                                        <label className="large-label float-lb">
                                            Count of Readers
                                        </label>
                                    </div>
                                    <div className="col-sm-6 float-field mt-1">
                                        <select className="form-control form-control-user" onChange={(e) => {
                                            setReaderMake(e.target.value)
                                        }} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                            <option value="">Select Barrier Make</option>
                                            {dropdownValue?.barrier_make!== undefined && dropdownValue?.barrier_make.map((val) => {
                                                return (
                                                    <>
                                                        {(parseInt(accountDetailsByIdData?.reader_make_id) === val?.id) ?
                                                            <>
                                                                return (
                                                                <option value={val?.id} selected>{val.name}</option>
                                                                )
                                                            </> :
                                                            <option value={val?.id}>{val.name}</option>
                                                        }
                                                    </>
                                                )
                                            })}
                                        </select>
                                        <label className="large-label float-lb">
                                            Reader Make
                                        </label>
                                    </div>
                                    <div className="col-sm-6 float-field mt-1">
                                        <select className="form-control form-control-user" onChange={(e) => {
                                            ReaderAgeOfSetUp(e.target.value)
                                        }} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                            <option value="">Select Age Of Setup</option>
                                            {dropdownValue?.age_of_reader!== undefined && dropdownValue?.age_of_reader.map((val) => {
                                                return (
                                                    <>
                                                        {(parseInt(accountDetailsByIdData?.reader_age_of_setup) === val?.id) ?
                                                            <>
                                                                return (
                                                                <option value={val?.id} selected>{val.name}</option>
                                                                )
                                                            </> :
                                                            <option value={val?.id}>{val.name}</option>
                                                        }
                                                    </>
                                                )
                                            })}
                                        </select>
                                        <label className="large-label float-lb">
                                            Age Of Setup
                                        </label>
                                    </div>
                                </>
                            }
                            {!isView && accountDetailsByIdData?.ev_vehicle !== null && accountDetailsByIdData?.ev_vehicle !== '' &&
                                <div className="col-sm-6 float-field mtk-075 d-mtk-1">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setEvVehicle(e.target.value)
                                    }} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                        <option value="">Select EV Vehicles</option>
                                        {accountDetailsByIdData?.ev_vehicle === 'yes' ?
                                            <>
                                                <option value="yes" selected>Yes</option>
                                                <option value="no">No</option>
                                            </> :
                                            accountDetailsByIdData?.ev_vehicle === 'no' ?
                                                <>
                                                    <option value="yes">Yes</option>
                                                    <option value="no" selected>No</option>
                                                </> :
                                                <>
                                                    <option value="yes">Yes</option>
                                                    <option value="no">No</option>
                                                </>
                                        }
                                    </select>
                                    <label className="large-label float-lb">
                                        EV Vehicles
                                    </label>
                                </div>
                            }

                            {evVehicle === 'yes' &&
                                <div className="col-sm-6 float-field mt-1">
                                    <input type="number"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'no_of_ev_vehicles')
                                           }}
                                           required
                                        // value={accountDetailsByIdData?.no_of_ev_vehicles}
                                           value={inputList[0]?.no_of_ev_vehicles}
                                           disabled={isView}
                                    />
                                    <label className="large-label float-lb">
                                        No of EV Vehicles <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Society;